import "vite/modulepreload-polyfill";

import { VueQueryPlugin } from "@tanstack/vue-query";
import { createApp } from "vue";

import App from "./components/App.vue";

// Newsletter and subscriber_facing_authentication should be defined via json_script tags in the template
// eslint-disable-next-line
const newsletterElement = document.getElementById("newsletter");
// eslint-disable-next-line
const subscriberFacingAuthElement = document.getElementById(
  "subscriber_facing_authentication"
);

if (newsletterElement && subscriberFacingAuthElement) {
  // eslint-disable-next-line no-undef
  const NEWSLETTER = JSON.parse(newsletterElement.textContent);
  // eslint-disable-next-line no-undef
  const SUBSCRIBER_FACING_AUTHENTICATION = JSON.parse(
    subscriberFacingAuthElement.textContent
  );

  // Determine variant - use global VARIANT if set, otherwise check for email element
  // eslint-disable-next-line no-undef
  const VARIANT =
    typeof window !== "undefined" && window.VARIANT
      ? window.VARIANT
      : document.getElementById("email")
      ? "archive_page"
      : "subscribe_page";

  const app = createApp(App, {
    newsletter: NEWSLETTER,
    subscriberFacingAuthentication: SUBSCRIBER_FACING_AUTHENTICATION || {
      status: "unauthenticated",
      email_address: null,
      subscribers: [],
    },
    variant: VARIANT,
  });

  app.use(VueQueryPlugin);

  // Mount to body since App.vue is a provider component that doesn't render visible content
  app.mount(document.getElementById("subscriber-facing-app"));
}
